
export const TOGGLE_DARK_MODE = 'TOGGLE_DARK_MODE';
export const SET_LIVESTREAM_URL = 'SET_LIVESTREAM_URL';
export const SET_PLAY_STREAM = 'SET_PLAY_STREAM';
export const SET_ALLOWED_CONFIG = 'SET_ALLOWED_CONFIG';
export const ENABLE_COMMISSION = 'ENABLE_COMMISSION';
